<!--  -->
<template>
  <div class="add_remark_Modal">
    <Modal v-model="is_show" title="邀约面试" @on-visible-change="modalChange">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="面试职位" prop="job_name">
          <Input v-model="formValidate.job_name" readonly placeholder="面试职位"></Input>
        </FormItem>

        <FormItem label="面试方式" prop="method">
          <Select v-model="formValidate.method" placeholder="面试方式" @on-change="method_change">
            <Option value="到朝九晚四云埔中心面试">到朝九晚四云埔中心面试</Option>

            <Option value="到本企业面试">到本企业面试</Option>

          </Select>
        </FormItem>

        <FormItem label="面试日期时间" prop="date">
          <DatePicker type="datetime" format="yyyy-MM-dd HH:mm:ss" placeholder="面试日期时间" style="width: 200px" v-model="formValidate.date"></DatePicker>
        </FormItem>

        <FormItem label="面试地点">
          <div style="display:flex">
            <Input v-model="formValidate.address.address" placeholder="面试地点"></Input>
            <div style="width:10%;text-align:center">
              <img @click="open_Modal" src="@/assets/images/B_user/address.png" alt="">
            </div>
          </div>
        </FormItem>

        <FormItem label="联系方式" prop="contact">
          <Input v-model="formValidate.contact" placeholder="联系方式"></Input>
        </FormItem>

        <FormItem label="注意事项">
          <Input v-model="formValidate.matters" type="textarea" :autosize="{ minRows: 3 }" placeholder="注意事项"></Input>
        </FormItem>

        <p style="text-align: center; color: red">标红星项为必填项，请按要求填写！</p>
      </Form>

      <div slot="footer">
        <Button type="text" @click="is_show = false">取消</Button>
        <Button :loading="but_loading" type="primary" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
    <Modal v-model="address_model" title="地图选点" :styles="{top: '20px'}" footer-hide>
      <iframe id="mapPage" width="100%" height="800px" frameborder=0 src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=4YYBZ-BIGCG-IMDQT-IOPQG-R77A6-KOFNR&referer=myapp">
      </iframe>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      but_loading: false,
      is_show: false,
      formValidate: {
        job_name: "",
        _resumeId: "",
        userId: "",
        position: "",
        date: "",
        method: "",
        contact: "",
        address: {
          address: "",
          gps: {
            x: 1,
            y: 2
          }
        },
        matters: "",
      },
      ruleValidate: {
        job_name: [{ required: true, message: "面试职位", trigger: "blur" }],
        method: [{ required: true, message: "请选择面试方式", trigger: "change" }],
        date: [
          { required: true, type: "date", message: "请选择面试时间", trigger: "change" },
        ],
        contact: [{ required: true, message: "面试职位", trigger: "blur" }],
      },
      //Modal
      address_model: false,
    };
  },
  methods: {
    //打开地图选点
    open_Modal() {
      this.address_model = true
    },
    //地图选点返回事件
    onMessage(event) {
      let loc = event.data
      if (loc && loc.module == 'locationPicker') {
        //防止其他应用也会向该页面post信息，需判断module是否为
        console.log(loc);
        //选点完毕关闭Modal
        this.address_model = false
        this.formValidate.address.address = loc.poiaddress + loc.poiname

        this.formValidate.address.gps.x = loc.latlng.lng
        this.formValidate.address.gps.y = loc.latlng.lat
      }
    },
    //改变面试方式时
    method_change(val) {
      if (val == '到朝九晚四云埔中心面试') {
        this.formValidate.address.address = val
        this.formValidate.address.gps = { x: 113.54678536441803, y: 23.10802881224816 }
      } else {
        this.formValidate.address.address = ''
        this.formValidate.address.gps = { x: 1, y: 1 }
      }
    },
    modalChange(bool) {
      if (bool) {
        //接收来自其他页面的消息并判断发送者
        window.addEventListener("message", this.onMessage);
       
        this.formValidate.contact = localStorage.getItem("invite_contact");
        this.formValidate.matters = localStorage.getItem("invite_matters");

      } else {
        this.formValidate.method = "";
        this.formValidate.date = "";
        this.$refs["formValidate"].resetFields();
        this.but_loading = false;
      }
    },
    //面试邀约时间改变
    Date_change(val) {
      this.formValidate.date = val
    },
    //提交
    handleSubmit(name) {

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.but_loading = true;

          //深拷贝 不改变原来对象
          let newdata = JSON.parse(JSON.stringify(this.formValidate));
          if (newdata.address.gps.x == 1) {
            this.$Message.warning('请定点选择位置');
            return
          }
          console.log(newdata);

          newdata.date = this.dayjs(newdata.date).format("YYYY-MM-DD HH:mm:ss");
          console.log(newdata);
          this.app("enterpriseOperators", "sendInterview", newdata).then((res) => {
            console.log(res);
            this.$Message.warning(res.message);
            if (res.code == 200) {
              //保存信息为下次默认
              localStorage.setItem("invite_contact", newdata.contact); //联系方式
              localStorage.setItem("invite_matters", newdata.matters); //注意事项
              this.but_loading = false;
              this.is_show = false;
              this.$emit("change");
            }
          });
        } else {
          this.$Message.error("请填写完整信息");
        }
      });
    },
  },
  created() { },
};
</script>

<style lang="less" scoped>
/deep/.ivu-modal {
  width: 530px !important;
}
</style>
